import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TriageTable from "../../components/triage/TriageTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function TriageList() {
  const { t } = useTranslation("vehicles");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Triage"),
      desc: t("Vehicles with Triage still in progress"),
    });
  }, [t]);

  return <TriageTable />;
}
